var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var SubNavListItem = createReactClass({
	mixins: [PureRenderMixin],
	render: function(){
		return (
			<li><a href={'#' + this.props.arrival + '-topic'} title={this.props.title}>{this.props.name}</a></li>
	    )
	}
});

module.exports = SubNavListItem;


// WEBPACK FOOTER //
// ./src/common/routes/education/components/layout/subNavListItem.jsx